import { gql } from '@apollo/client';

const UPDATE_PRIVACY_V2 = gql`
  mutation UpdateUserPreferences($input: UpdateUserPreferencesInput!) {
    updateUserPreferencesV2(input: $input) {
      preferences {
        isReceivingPUDOptimization
        isReceivingPUDGoToMarket
      }
    }
  }
`;

export default UPDATE_PRIVACY_V2;
